import {Component, OnInit} from '@angular/core';
import {NbComponentStatus, NbDialogRef, NbGlobalPosition, NbToastrService} from '@nebular/theme';
import {RestreamsService} from '../../shared/services/restreams.service';
import {RestreamProject, SrtStatusResponse} from '../../shared/interfaces';
import {srtReasonText} from '../srt-reasons';

const TEXT = {
  copied: 'Скопійовано',
  titleSaved: 'Назву збережено',
  titleFailed: 'Не вдалося зберегти назву',
  latencySaved: (ms: number) => 'Затримку змінено на ' + ms + ' мс',
  latencyFailed: 'Не вдалося змінити затримку',
  keyCreated: 'Новий ключ створено',
  keyFailed: 'Не вдалося змінити ключ',
  locale: 'uk-UA'
}

@Component({
  selector: 'app-srt-point-modal',
  templateUrl: './srt-point-modal.component.html',
  styleUrls: ['./srt-point-modal.component.scss']
})
export class SrtPointModalComponent implements OnInit {

  restream: RestreamProject
  status: SrtStatusResponse
  titleValue = ''
  saving = false
  rotating = ''
  confirmRotate = ''
  latencySaving = false
  latencies = [200, 500, 1000, 2000]
  show = {publish: false, read: false}
  masked = '••••••••••••••••••••'

  constructor(
    protected ref: NbDialogRef<SrtPointModalComponent>,
    private restreamsService: RestreamsService,
    private toastrService: NbToastrService
  ) {
  }

  ngOnInit(): void {
    this.titleValue = this.restream.title || ''
    if (this.status && this.status.srtLatenciesMs && this.status.srtLatenciesMs.length) {
      this.latencies = this.status.srtLatenciesMs
    }
  }

  get point() {
    return this.restream.srt
  }

  get serverUrl(): string {
    return this.point ? this.point.publishUrl.split('?')[0] : ''
  }

  get publishStreamId(): string {
    return this.streamIdOf(this.point && this.point.publishUrl)
  }

  get readStreamId(): string {
    return this.streamIdOf(this.point && this.point.readUrl)
  }

  get quotaPercent(): number {
    if (!this.status || !this.status.quota.limit) {
      return 0
    }
    return Math.min(100, Math.round(this.status.quota.used / this.status.quota.limit * 100))
  }

  get lastEventText(): string {
    return this.point && this.point.lastEvent ? srtReasonText(this.point.lastEvent) : ''
  }

  get lastEventTime(): string {
    return this.point && this.point.lastEvent ? new Date(this.point.lastEvent.at).toLocaleString(TEXT.locale) : ''
  }

  maskedUrl(kind: 'publish' | 'read'): string {
    return this.serverUrl + '?streamid=' + kind + ':••••••••'
  }

  copied() {
    this.toast(TEXT.copied, 'success')
  }

  saveTitle() {
    const title = this.titleValue.trim()
    if (!title || title === this.restream.title || this.saving) {
      return
    }
    this.saving = true
    this.restreamsService.update(this.restream._id, undefined, title).subscribe((updated) => {
      this.restream.title = updated.title
      this.saving = false
      this.toast(TEXT.titleSaved, 'success')
    }, () => {
      this.saving = false
      this.toast(TEXT.titleFailed, 'danger')
    })
  }

  setLatency(ms: number) {
    if (this.latencySaving || !this.point || this.point.latencyMs === ms) {
      return
    }
    this.latencySaving = true
    this.restreamsService.setSrtLatency(this.restream._id, ms).subscribe(() => {
      this.refreshPoint(() => this.toast(TEXT.latencySaved(ms), 'success'))
    }, () => {
      this.latencySaving = false
      this.toast(TEXT.latencyFailed, 'danger')
    })
  }

  rotate(which: 'publish' | 'read') {
    this.rotating = which
    this.restreamsService.srtRotate(this.restream._id, which).subscribe((res) => {
      this.restream.srtPublishKey = res.point.srtPublishKey
      this.restream.srtReadKey = res.point.srtReadKey
      this.confirmRotate = ''
      this.refreshPoint(() => this.toast(TEXT.keyCreated, 'success'))
    }, () => {
      this.rotating = ''
      this.confirmRotate = ''
      this.toast(TEXT.keyFailed, 'danger')
    })
  }

  close() {
    this.ref.close()
  }

  private refreshPoint(done: () => void) {
    this.restreamsService.srtStatus().subscribe((status) => {
      const fresh = status.points.find((p) => p.id === this.restream._id)
      if (fresh) {
        this.restream.srt = fresh
      }
      this.status = status
      this.latencySaving = false
      this.rotating = ''
      done()
    }, () => {
      this.latencySaving = false
      this.rotating = ''
    })
  }

  private streamIdOf(url: string): string {
    if (!url) {
      return ''
    }
    const match = /[?&]streamid=([^&]+)/.exec(url)
    return match ? decodeURIComponent(match[1]) : ''
  }

  private toast(title: string, status: NbComponentStatus) {
    this.toastrService.show('', title, {status, position: <NbGlobalPosition>'bottom-end'})
  }
}
